// フッターナビゲーションの表示切替
(function($){
  var target=$([]);

  $.fn.toggleFooterNav = function(expr, options) {
    options = options||{};
    target = $.merge(target, this);
    this.on("change",function(){
      if (target.filter(":checked").length === 0) {
        $.unfixedUI();
        $("footer").removeClass("footerFixedVisible");
      } else {
        $.fixedUI(expr);
        $("footer").addClass("footerFixedVisible");
        // 一部のAndroidでフッターナビゲーションの要素が移動されない問題の対処
        if ($("#fixedUI #footerFixed").length === 0) $("#footerFixed").appendTo("#fixedUI");
      }
      if (!!options.callback) options.callback.apply(this);
    });
    this.last().trigger("change");
    return this;
  }

})(jQuery);
